import type { ContractPaymentsListRow } from "@/admin/entities/contractPayments";
import type { ContractPaymentsListQueryType } from "@/types/graphql/admin.generated";
import { ContractPaymentColumns, formatDay } from "@/admin/features/billing";
import { PagePaths } from "@/admin/shared/constants";

export function getTableData(data: unknown): {
  nodes: ContractPaymentsListRow[];
  count: number;
} {
  const typed = data as ContractPaymentsListQueryType;
  const result = typed?.contractPayments;
  if (!result?.nodes) return { nodes: [], count: 0 };
  return { nodes: result.nodes, count: result.count };
}

export function mapColumns(payment: ContractPaymentsListRow) {
  return [
    payment.id,
    payment,
    payment.invoiceDate,
    payment.expiredAt,
    payment,
    payment,
    payment,
    payment,
    payment,
  ];
}

export const getColumnsConfig = () => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "period",
    label: "Период",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const payment = data as ContractPaymentsListRow;
        return `${formatDay(payment.periodFrom)}, ${formatDay(payment.periodTo)}`;
      },
    },
  },
  ContractPaymentColumns.buildInvoiceDateColumn(),
  ContractPaymentColumns.buildExpiredAtColumn(),
  ContractPaymentColumns.buildAmountColumn(),
  ContractPaymentColumns.buildStatusColumn({
    cardPath: PagePaths.billingPayments,
  }),
  ContractPaymentColumns.buildLinesColumn(),
  ContractPaymentColumns.buildInvoiceNumberColumn(),
  ContractPaymentColumns.buildActionsColumn({
    cardPath: PagePaths.billingPayments,
  }),
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Платежи по контрактам",
  refetchList: "Обновить список",
  cancel: "Отмена",
  editItem: "Платёж",
  showTitle: "Детали",
});
